
import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import gameStart from './../../assets/img/game_start.png';
import gameScore from './../../assets/img/game_score.png';
import gameStop from './../../assets/img/game_stop.png';
import gamePlay from './../../assets/img/game_play.png';



const images = [
  {
    label: 'Select a Timeline!',
    imgPath: gameStart,
    description: 'Select a year in the timeline to begin your journey! Simply click on the year you want to start at and click "Jump into the time machine" to begin!',
  },
  {
    label: 'Campaign Stops',
    imgPath: gameStop,
    description: 'A game stop is a brief pause in your journey where you\'ll receive information about the next level of the game. It\'s like a signpost on your path to the presidency, giving you a glimpse of the challenges and decisions you\'ll face in the upcoming stage. For example, you might learn about the key issues that were important to voters during a specific time period. Use these game stops to strategize and plan your next moves carefully!',

  },
  {
    label: 'Game Play',
    imgPath: gamePlay,
    description: 'You\'ll be presented with a question and a set of answers. You\'ll need to choose the answer that you think is the most popular among voters. You\'ll also need to rank the answers in order of popularity. You\'ll get points for each answer you get right, and the more points you get, the more voters you\'ll reach! Be careful, though - if you get an answer wrong, you\'ll lose points!',
  },
  {
    label: 'Final Score',
    imgPath: gameScore,
    description: 'At the end of the game, you\'ll see how many points you earned. You can play again to try to beat your score and reach even more voters!',
    
  },
];

function CarouselModal(props) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleDone = () => {
    // Close Modal from parent
    props.handleCloseModal()
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          mb: 2,
        }}
      >
        <Typography>{images[activeStep].label}</Typography>
      </Paper>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents>
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box
                component="img"
                sx={{
                  display: 'block',
                  overflow: 'hidden',
                  width: '100%',
                }}
                src={step.imgPath}
                alt={step.label}
              />
            ) : null}
          </div>
        ))}
      </SwipeableViews>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          mt: 2,
        }}
      >
        <Typography sx={{fontStyle: 'italic'}}>{images[activeStep].description}</Typography>
      </Paper>
      <MobileStepper
        variant='text'
        padding={0}
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={activeStep === maxSteps - 1 ? handleDone: handleNext}
          >
            {activeStep === maxSteps - 1 ? 'Done' : 'Next'}
            {
              activeStep === maxSteps - 1 ? null :
              <KeyboardArrowRight />
            }
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </Box>
  );
}

export default CarouselModal